import useSWR from "swr";

interface SubscriptionPolicy {
  cancellationText: string;
  cancellationDaysSincePaymentFailure: number;
  allowSelfCancellation: boolean;
}

interface UseSubscriptionPolicyQueryReturn {
  data: SubscriptionPolicy | undefined;
}

export function useSubscriptionPolicyQuery(
  membershipPlanId?: string
): UseSubscriptionPolicyQueryReturn {
  const { data } = useSWR(
    membershipPlanId
      ? `/api/v2/membership_plans/${membershipPlanId}/policy`
      : null
  );

  return { data: toSubscriptionPolicy(data?.data) };
}

function toSubscriptionPolicy(data?: any): SubscriptionPolicy | undefined {
  try {
    if (data) {
      return {
        allowSelfCancellation: data.allow_self_cancellation,
        cancellationText: data.cancellation_text,
        cancellationDaysSincePaymentFailure:
          data.cancellation_days_since_payment_failure,
      };
    }
  } catch {
    throw new Error("Error mapping data");
  }
}
